import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getEquipmentDocuments(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENTS,
		options
	)
}

function _getEquipmentDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENT,
		options
	)
}

function _createEquipmentDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].CREATE_EQUIPMENT_DOCUMENT,
		options
	)
}

function _patchEquipmentDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PATCH_EQUIPMENT_DOCUMENT,
		options
	)
}

function _putEquipmentDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PUT_EQUIPMENT_DOCUMENT,
		options
	)
}

function _deleteEquipmentDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].DELETE_EQUIPMENT_DOCUMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENTS]: _getEquipmentDocuments,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENT]: _getEquipmentDocument,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].CREATE_EQUIPMENT_DOCUMENT]: _createEquipmentDocument,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PATCH_EQUIPMENT_DOCUMENT]: _patchEquipmentDocument,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PUT_EQUIPMENT_DOCUMENT]: _putEquipmentDocument,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].DELETE_EQUIPMENT_DOCUMENT]: _deleteEquipmentDocument,
}
